export default __webpack_public_path__ + "static/media/Atom.e2b8c761.gif";